import { AddonFeatureManager } from 'core';
import {
  RtbCampaignSetupFlowPageModel,
  CreateRtbCampaignSetupFlowPageModel,
  EditRtbCampaignSetupFlowPageModel,
  CopyRtbCampaignSetupFlowPageModel,
  SplitRtbCampaignSetupFlowPageModel,
} from './RtbCampaignSetupFlow/RtbCampaignSetupFlowPageModel';
import { SelectOptions } from 'components/commonType';
import { Order } from 'core/order/Order';
import { L1ObjectChannel } from 'core/l1Object/L1Object';

export interface RtbCampaignsModel {
  readonly order: Order;
  readonly addonFeatureManager: AddonFeatureManager;
  readonly channel: L1ObjectChannel;
  getCampaignCreateModel(localeMeta): RtbCampaignSetupFlowPageModel;
  getCampaignEditModel(
    campaignId: number,
    localeMeta,
  ): RtbCampaignSetupFlowPageModel;
  getCampaignCopyModel(
    campaignId: number,
    localeMeta,
  ): RtbCampaignSetupFlowPageModel;
  getCampaignSplitModel(
    campaignId: number,
    localeMeta,
  ): RtbCampaignSetupFlowPageModel;
  setOrder(order: Order): void;
}

export type RtbCampaignsProps = {
  readonly model: RtbCampaignsModel;
};

export class DefaultRtbCampaignsModel implements RtbCampaignsModel {
  addonFeatureManager: AddonFeatureManager;
  advertisers?: Array<SelectOptions>;
  campaignCreateModel?: RtbCampaignSetupFlowPageModel;
  campaignEditModel?: EditRtbCampaignSetupFlowPageModel;
  campaignCopyModel?: CopyRtbCampaignSetupFlowPageModel;
  campaignSplitModel?: SplitRtbCampaignSetupFlowPageModel;

  order: Order;
  channel: L1ObjectChannel;

  constructor(order: Order, addonFeatureManager: AddonFeatureManager) {
    this.order = order;
    this.channel = L1ObjectChannel.RTB;
    this.addonFeatureManager = addonFeatureManager;
  }

  setOrder(order: Order) {
    this.order = order;
    this.campaignCreateModel && this.campaignCreateModel.setOrder(order);
    this.campaignEditModel && this.campaignEditModel.setOrder(order);
    this.campaignCopyModel && this.campaignCopyModel.setOrder(order);
  }

  getCampaignCreateModel(localeMeta): RtbCampaignSetupFlowPageModel {
    if (this.campaignCreateModel) {
      return this.campaignCreateModel;
    }

    this.campaignCreateModel = new CreateRtbCampaignSetupFlowPageModel(
      this.order,
      this.addonFeatureManager,
      localeMeta,
    );
    return this.campaignCreateModel;
  }

  getCampaignEditModel(
    campaignId: number,
    localeMeta,
  ): RtbCampaignSetupFlowPageModel {
    if (
      this.campaignEditModel &&
      this.campaignEditModel.campaignId === campaignId
    ) {
      return this.campaignEditModel;
    }
    this.campaignEditModel = new EditRtbCampaignSetupFlowPageModel(
      campaignId,
      this.order,
      this.addonFeatureManager,
      localeMeta,
    );
    return this.campaignEditModel;
  }

  getCampaignCopyModel(
    campaignId: number,
    localeMeta,
  ): RtbCampaignSetupFlowPageModel {
    if (
      this.campaignCopyModel &&
      this.campaignCopyModel.campaignId === campaignId
    ) {
      return this.campaignCopyModel;
    }

    this.campaignCopyModel = new CopyRtbCampaignSetupFlowPageModel(
      campaignId,
      this.order,
      this.addonFeatureManager,
      localeMeta,
    );
    return this.campaignCopyModel;
  }

  getCampaignSplitModel(
    campaignId: number,
    localeMeta,
  ): RtbCampaignSetupFlowPageModel {
    if (
      this.campaignSplitModel &&
      this.campaignSplitModel.campaignId === campaignId
    ) {
      return this.campaignSplitModel;
    }

    this.campaignSplitModel = new SplitRtbCampaignSetupFlowPageModel(
      campaignId,
      this.order,
      this.addonFeatureManager,
      localeMeta,
    );
    return this.campaignSplitModel;
  }
}
